import { Button, cn, Icon } from "@kyan/ui";

export interface ExpandButtonProps {
  referralCount: number;
  isExpanded: boolean;
  onClick: () => void;
}

export const ExpandButton: React.FC<ExpandButtonProps> = ({
  referralCount,
  isExpanded,
  onClick,
}) => {
  if (referralCount < 2) return null;

  return (
    <Button
      variant="secondary"
      className="text-textSecondary flex h-11 w-31 gap-2 font-sans"
      onClick={onClick}
    >
      {isExpanded ? "Close" : `View all (${referralCount})`}
      <Icon
        size="xs"
        name="caret-down"
        className={cn("transition-transform", {
          "rotate-180": isExpanded,
        })}
      />
    </Button>
  );
};
